module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-stone-path.00857ba6.png";